import { AnyAction } from 'redux';
import { ITableSort } from 'src/utils/SortUtils';
import { ActionTypes } from '../actions/ActionTypes';

export interface IDynTableState {
  /** dynTable */
  dynTableSelectedIdList: string[];
  dynTabelRollback: boolean;
  optionTableSort: ITableSort;
  dynTableReload: boolean;
  optionBasicTableSort: ITableSort;
}

const INITIAL_STATE: IDynTableState = {
  dynTabelRollback: false,
  dynTableSelectedIdList: [],
  optionTableSort: {
    categoryText: true,
    intSequence: true,
  },
  dynTableReload: false,
  optionBasicTableSort: {
    categoryText: true,
    intSequence: true,
  },
};

export const dynTableReducer = (
  state: IDynTableState = INITIAL_STATE,
  action: AnyAction
): IDynTableState => {
  switch (action.type) {
    case ActionTypes.DYNTABLE_ROLLBACK:
      return {
        ...state,
        dynTabelRollback: action.dynTabelRollback,
      };
    case ActionTypes.DYNTABLE_RELOAD:
      return {
        ...state,
        dynTableReload: action.dynTableReload,
      };
    case ActionTypes.SET_OPTION_TABLE_SORT:
      return {
        ...state,
        optionTableSort: action.sortObject,
      };
    case ActionTypes.DYNTABLE_SELECTEDIDLIST:
      return {
        ...state,
        dynTableSelectedIdList: action.idList,
      };
    case ActionTypes.SET_OPTION_BASIC_TABLE_SORT:
      return {
        ...state,
        optionBasicTableSort: action.sortObject,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/dynTableReducer.ts